import {ColorType} from 'grommet/utils'

// https://grommet-theme-builder.netlify.app/
// Tips: https://spin.atomicobject.com/2021/05/14/styling-grommet/

const colors: {[name: string]: ColorType} = {
  // Grommet's black and white might be enough, as there are
  // multiple shades
  // black: '#191716',
  // white: '#f7f9f9',
  brand: {
    light: '#eda900',
    dark: '#fbc02d',
  },
  'accent-1': {
    light: '#2d728f',
    dark: '#2d728f',
  },
  text: {
    light: '#191716',
    dark: '#f7f9f9',
  },

  /*
    We can overwrite them as we need. Here's the list: https://v2.grommet.io/color

    active?: ColorType;
    border?: ColorType;
    control?: ColorType;
    focus?: ColorType;
    placeholder?: ColorType;
    selected?: ColorType;
    icon?: ColorType;
    'accent-1'?: ColorType;
    'accent-2'?: ColorType;
    'accent-3'?: ColorType;
    'accent-4'?: ColorType;
    'background-back'?: ColorType;
    'background-contrast'?: ColorType;
    'background-front'?: ColorType;
    'neutral-1'?: ColorType;
    'neutral-2'?: ColorType;
    'neutral-3'?: ColorType;
    'neutral-4'?: ColorType;
    'dark-1'?: ColorType;
    'dark-2'?: ColorType;
    'dark-3'?: ColorType;
    'dark-4'?: ColorType;
    'dark-5'?: ColorType;
    'dark-6'?: ColorType;
    'light-1'?: ColorType;
    'light-2'?: ColorType;
    'light-3'?: ColorType;
    'light-4'?: ColorType;
    'light-5'?: ColorType;
    'light-6'?: ColorType;
    'status-critical'?: ColorType;
    'status-error'?: ColorType;
    'status-warning'?: ColorType;
    'status-ok'?: ColorType;
    'status-unknown'?: ColorType;
    'status-disabled'?: ColorType;
    'graph-0'?: ColorType;
    'graph-1'?: ColorType;
    'graph-2'?: ColorType;
    'graph-3'?: ColorType;
    'graph-4'?: ColorType;
    'graph-5'?: ColorType;
  */
}

export default colors
